<template>
  <div>
    <div class="page_title">
      积分比例设置（用户诊疗）
    </div>
    <div style="padding:20px;">
      <div class="container">
        <div
          v-for="(item,index) in ruleList"
          :key="index"
          class="list_item"
        >
          <span
            class="title"
            v-if="item.type==1"
          >支付问诊费</span>
          <span
            class="title"
            v-if="item.type==2"
          >支付处方订单</span>
          <el-input-number
            v-model="item.rule_money"
            :min="0"
            :precision="1"
            :controls="false"
            style="width:100px"
            :disabled="!item.edit"
          ></el-input-number>
          <span> 元 ---> 1 积分 </span>

          <span style="margin-left:15px">
            <span style="margin-right:8px">是否启用</span>
            <el-radio-group v-model="item.status">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </span>
          <el-button
            type="primary"
            size="medium"
            style="margin-left:50px"
            @click="item.edit=true"
            v-if="!item.edit"
            :disabled="
                module_id_array[0] ? !module_id_array.includes('918') : false
              "
          >修改</el-button>
          <span
            style="margin:0 40px 0 15px"
            v-if="item.edit"
          >
            <el-button
              type="primary"
              size="medium"
              @click="submit(item.type,item.rule_money,item.status)"
            >保存</el-button>
            <el-button
              plain
              size="medium"
              @click="getList"
            >取消</el-button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      num: undefined,
      radio: 1,
      ruleList: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    //获取信息
    getList() {
      this.axios.post('platform/Integral/getIntegralRuleList').then((res) => {
        this.ruleList = res.data.list.map((item) => {
          item.edit = false;
          return item;
        });
      });
    },
    //提交保存
    submit(type, rule_money, status) {
      if (!rule_money) {
        this.$message.error('请设置费用');
        return false;
      }
      let data = {
        type,
        rule_money,
        status
      };
      this.axios
        .post('platform/Integral/updateIntegralRuleInfo', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.getList();
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.title {
  display: inline-block;
  font-weight: 700;
  width: 120px;
}
.list_item {
  margin-bottom: 20px;
}
</style>


